import React from "react";
import { QuotedRateIcon } from "../../../icons/QuotedRateIcon";
import { QuotedRateNotifiedIcon } from "../../../icons/QuotedRateNotifiedIcon";
import styles from "../QuoteMultipleDestinationsPanel.module.css";

interface QuotedRateHeaderProps {
  notified: boolean;
  isNotifying: boolean;
  onNotifyRailTeam: () => void;
}

const QuotedRateHeader: React.FC<QuotedRateHeaderProps> = ({
  notified,
  isNotifying,
  onNotifyRailTeam,
}) => {
  let notifyRailTeamLabel = "Notify the Rail Team";
  if (notified) {
    notifyRailTeamLabel = "Rail Team Notified";
  } else if (isNotifying) {
    notifyRailTeamLabel = "Notifying...";
  }

  return (
    <div className={styles.quotedRateHeaderContainer}>
      {/* Heading row */}
      <div className={styles.quotedRateHeaderRow}>
        {notified ? <QuotedRateNotifiedIcon /> : <QuotedRateIcon />}
        <span className={styles.quotedRateHeaderTitle}>Quoted Rail Rate</span>
      </div>

      {/* Description */}
      <p className={styles.quotedRateHeaderDescription}>
        {notified
          ? "The Rail team has been notified to get this rate published."
          : "This is a quoted freight rate from the carrier. Please notify the rail team so they can coordinate with the railroad to get this rate published."}
      </p>

      {/* Notify button */}
      <button
        type="button"
        disabled={notified || isNotifying}
        onClick={onNotifyRailTeam}
        className={`${styles.quotedRateHeaderButton}${
          notified ? ` ${styles.notified}` : ""
        }`}
      >
        {notified ? (
          <QuotedRateNotifiedIcon color="#ffffff" />
        ) : (
          <QuotedRateIcon color="#ffffff" />
        )}
        <span className={styles.quotedRateHeaderButtonLabel}>
          {notifyRailTeamLabel}
        </span>
      </button>
    </div>
  );
};

export default QuotedRateHeader;
